import { useState } from 'react';
import Hero from './components/Hero';
import Reasons from './components/Reasons';
import UseCases from './components/UseCases';
import HowToUse from './components/HowToUse';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import QuoteSection from './components/QuoteSection';
import Company from './components/Company';
import Footer from './components/Footer';
import QuoteModal from './components/QuoteModal';
import ConsultModal from './components/ConsultModal';
import AlertModal from './components/AlertModal';

export default function Home() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const [isConsultModalOpen, setIsConsultModalOpen] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white pb-24 md:pb-0">
      <Hero 
        onQuoteClick={() => setIsQuoteModalOpen(true)}
        onConsultClick={() => setIsConsultModalOpen(true)}
      />
      <Reasons />
      <UseCases />
      <HowToUse onQuoteClick={() => setIsQuoteModalOpen(true)} />
      <Pricing onQuoteClick={() => setIsQuoteModalOpen(true)} />
      <Testimonials />
      <FAQ />
      <QuoteSection onQuoteClick={() => setIsQuoteModalOpen(true)} />
      <Company />
      <Footer 
        onQuoteClick={() => setIsQuoteModalOpen(true)}
        onContactClick={() => setIsConsultModalOpen(true)}
      />
      
      <QuoteModal 
        isOpen={isQuoteModalOpen}
        onClose={() => setIsQuoteModalOpen(false)}
        setIsAlertOpen={setIsAlertOpen}
      />
      <ConsultModal 
        isOpen={isConsultModalOpen}
        onClose={() => setIsConsultModalOpen(false)}
        setIsAlertOpen={setIsAlertOpen}
      />
      <AlertModal isOpen={isAlertOpen} onClose={() => setIsAlertOpen(false)} />
    </div>
  );
}
